<template>
    <div>
        <v-btn
                color="primary"
                dark
                @click.stop="dialog = true"
        >
            Add clients
        </v-btn>

        <v-dialog
                v-model="dialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Add new clients</v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-select
                            	v-validate="'required'"
                            	:error-messages="errors.collect('data.clientes')"
                            	data-vv-name="data.clientes"
								v-model="data.clientes"
								:items="clientes"
								:menu-props="{ maxHeight: '400' }"
								label="Select"
								multiple
								hint="Pick your clients"
								persistent-hint
								item-text="company_name"
								item-value="id"
					        ></v-select>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                            <v-btn block outline color="red" v-if="message_error">{{ message_error}}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="green darken-1"
                            flat="flat"
                            @click="dialog = false"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                            color="green darken-1"
                            flat="flat"
                            @click="create"
                    >
                        Add
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: ['laboratorio_id'],
        data () {
            return {
                data: {},
                dialog: false,
                error : false,
                message_error : null,
                clientes: [],
                loading: true
            }
        },
        created () {
        	
        },
        watch: {
            dialog: function() {
                if (this.dialog == true) {
                    this.data = {};
                    this.getSelectClientes();
                }
            }
        },
        methods: {
        	getSelectClientes () {
        		var params = {
                    filters : {
                        laboratorio_id: this.laboratorio_id
                    }
                };
                this.$store.dispatch('getLaboratorioSelectClientes', params).then((res) => {
                    this.clientes = res.data.data;
                    this.loading = false;
                }).catch((error) => {

                });
        	},
            create : function() {
            	this.$validator.validateAll().then((result) => {
                    if(result){
                        this.data.laboratorio_id = this.laboratorio_id;
                        this.$store.dispatch('addLaboratorioClientes', this.data).then((res) => {

                            this.dialog = false;

                            this.$emit('update');

                        }).catch((error) => {
                            this.message_error = error.data.errors.email[0];
                        });
                    }
                });

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/amcs/components/AddClientsModal.vue